// extracted by css-extract-rspack-plugin
export default {"loadingContainer":"CopilotChatPanelContent-module__loadingContainer__NS25Z"};